import React from 'react';
import { Invoice } from '../../../components/service/subscription/invoice/Invoice';
export const InvoicePageView = () => {
  return <Invoice data-sentry-element="Invoice" data-sentry-component="InvoicePageView" data-sentry-source-file="[id].tsx" />;
};